module.exports = require("purdy");


//////////////////
// WEBPACK FOOTER
// external "purdy"
// module id = 2
// module chunks = 0 1